import Croppie from 'croppie';

export default class ImageEditor {
  constructor(el) {
    this.el = el;
    this.refererURL = this.el.getAttribute('data-referer').trim();
    this.rotateBtn = this.el.querySelector('.rotate-button');
    this.removeBtn = this.el.querySelector('.remove-button');
    this.saveBtn = this.el.querySelector('.save-button');
    this.workContainerRot = this.el.querySelector('.work-container-rot');
    this.workContainerCrop = this.el.querySelector('.work-container-crop');
    this.modulemode = this.el.getAttribute('data-module-mode');
    this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    if (this.modulemode === 'crop') {
      this.cropResult = document.querySelector('.crop-result');
      this.cropSave = document.querySelector('.crop-save');
      this.cropRotate = document.querySelector('.crop-rotate');
      this.image = this.el.getAttribute('data-crop-file');
      this.cropWork();
    }
    if (this.modulemode === 'rot') {
      this.saveBtn.addEventListener('click', () => {
        $.ajax({
          url: '/support/img_editor/operations.php',
          method: 'POST',
          type: 'json',
          data: {
            mode: 'save',
            uid: this.el.getAttribute('data-uid'),
            file: this.el.getAttribute('data-file'),
            type: this.el.getAttribute('data-type'),
            o: this.el.getAttribute('data-o')
          },
          success: data => {
            const response = $.parseJSON(data);
            if (response.success === 'ok') {
              window.location = this.refererURL;
            }
          }
        });
      });
      this.rotateBtn.addEventListener('click', () => {
        $.ajax({
          url: '/support/img_editor/operations.php',
          method: 'POST',
          type: 'json',
          data: {
            mode: 'rotate',
            type: this.el.getAttribute('data-type'),
            uid: this.el.getAttribute('data-uid'),
            file: this.el.getAttribute('data-file')
          },
          success: data => {
            const response = $.parseJSON(data);
            const otra = response.new_url;
            const newIMG = new Image();
            const now = Date.now();
            newIMG.src = `${otra}?${now}`;
            newIMG.classList.add('img-responsive');
            this.workContainerRot.innerHTML = '';
            this.workContainerRot.appendChild(newIMG);
          }
        });
      });
      this.removeBtn.addEventListener('click', () => {
        // eslint-disable-next-line
        const res = confirm('Sicher löschen?');
        if (res) {
          $.ajax({
            url: '/hier eine adresse',
            method: 'POST',
            type: 'json',
            data: {
              mode: 'remove'
            },
            success: () => {
              this.workContainer.innerHTML = '';
            }
          });
        }
      });
    }
  }

  cropWork() {
    const c = new Croppie(document.getElementById('crop-work'), {
      viewport: {
        width: 199,
        height: 265
      },
      boundary: {
        width: 450,
        height: 600
      },
      enableOrientation: true,
      enableResize: false,
      mouseWheelZoom: 'ctrl'
    });
    c.bind({
      url: this.image
    });
    this.cropResult.addEventListener('click', () => {
      c.result({
        type: 'canvas',
        format: 'jpeg',
        quality: 1
      }).then(this.resultCrop);
    });
    this.cropSave.addEventListener('click', () => {
      c.result({
        type: 'canvas',
        format: 'jpeg',
        quality: 1
      }).then(this.saveCrop);
    });
    this.cropRotate.addEventListener('click', e => {
      c.rotate(parseInt(e.target.getAttribute('data-deg'), 10));
    });
  }

  resultCrop(result) {
    const resultWrapper = document.getElementById('image-cropped');
    const img = new Image();
    img.src = result;
    resultWrapper.innerHTML = '';
    resultWrapper.appendChild(img);
  }

  saveCrop(result) {
    const el = document.getElementById('imageeditor-wrapper');
    const refererURL = el.getAttribute('data-referer');
    const mytype = el.getAttribute('data-type');
    const userid = el.getAttribute('data-uid');
    const original = el.getAttribute('data-0');
    const data = {
      mode: 'save_min',
      uid: userid,
      file: result,
      type: mytype,
      o: original
    };
    $.ajax({
      url: '/support/img_editor/operations.php',
      method: 'POST',
      type: 'json',
      data,
      success: res => {
        const response = $.parseJSON(res);
        if (response.success === 'ok') {
          window.location = refererURL;
        }
      }
    });
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/imageeditor.js